import { trackDomainAnalytics } from 'lib/eventTracking'

export default trackDomainAnalytics('Common Cartridge')
